import { useEffect, useRef } from "react"

export const useClickOutside = (handler: () => void, skipRefs: React.RefObject<HTMLElement>[] = []) => {
  const wrapperRef = useRef<HTMLElement>(null)

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const skipElements = skipRefs.map((r) => r.current).filter((r) => !!r) as HTMLElement[]

      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node) &&
        skipElements.every((e) => !e.contains(event.target as Node))
      ) {
        handler()
      }
    }

    // Bind the event listener
    const rootElement = document.getElementById("root")
    rootElement?.addEventListener("mousedown", handleClickOutside)

    return () => {
      // Unbind the event listener on clean up
      rootElement?.removeEventListener("mousedown", handleClickOutside)
    }
  }, [wrapperRef, handler, ...skipRefs])

  return wrapperRef
}
